import { Component, input, output, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { environment } from '../../../../environments/environment';

export interface NavItem {
  label: string;
  icon: string;
  route: string;
}

@Component({
  selector: 'nf-sidebar',
  imports: [RouterLink, RouterLinkActive, MatIconModule, MatButtonModule],
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.scss',
})
export class SidebarComponent {
  collapsed = input(false);
  collapsedChange = output<boolean>();
  mobileOpen = input(false);
  mobileOpenChange = output<boolean>();

  protected readonly orgShortName = environment.orgShortName;
  protected readonly orgName = environment.orgName;

  protected readonly navItems: NavItem[] = [
    { label: 'Dashboard', icon: 'home', route: '/dashboard' },
    { label: 'Documents', icon: 'description', route: '/documents' },
    { label: 'Workflows', icon: 'account_tree', route: '/workflows' },
    { label: 'Memos', icon: 'mail', route: '/memos' },
    { label: 'Payments', icon: 'payments', route: '/payments' },
    { label: 'Directory', icon: 'people', route: '/directory' },
  ];

  protected toggleCollapse(): void {
    this.collapsedChange.emit(!this.collapsed());
  }

  protected closeMobile(): void {
    this.mobileOpenChange.emit(false);
  }
}
